export function addCurrent(automation) {
  return {
      type: 'ADD_CURRENT',
      automation,
  }
}